import React, { FC, useState } from 'react';
import { Box } from '@mui/material';
import { WorkoutData } from '../../../models/training.models';
import WorkoutZoneBreakdown from '../components/workout-zone-breakdown';
import WorkoutSplitsTable from '../components/workout-splits-table';
import WorkoutAnalyticsStackedGraph from '../components/workout-analytics-stacked-graph';

export interface AnalyticsTabProps {
  workoutData: WorkoutData | null | undefined;
}

const AnalyticsTab: FC<AnalyticsTabProps> = ({ workoutData }) => {
  const [selectedSplitNumber, setSelectedSplitNumber] = useState<number | null>(null);

  if (!workoutData) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        mt: 2.5,
        mb: 2,
        px: 2,
      }}
    >
      <WorkoutZoneBreakdown
        durationComplete={workoutData.durationComplete}
        distanceComplete={workoutData.distanceComplete}
      />
      <WorkoutAnalyticsStackedGraph workoutData={workoutData} selectedSplitNumber={selectedSplitNumber} />
      <WorkoutSplitsTable
        splits={workoutData.splits ?? []}
        selectedSplitNumber={selectedSplitNumber}
        onSelectSplit={setSelectedSplitNumber}
      />
    </Box>
  );
};

export default AnalyticsTab;
